export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_s-73fcb0c9cc7f2ca8c5123b404d03c65e.png";